import { Route } from 'react-router-dom';

import { AccessControllers } from './access-controllers/access-controllers.component';
import HardwareDashboard from './dashboard/dashboard.component';
import { Gates } from './gates/gates.component';
import { Infrastructure } from './infrastructure/infrastructure.component';

export const ApplicationHardwareRoutes = () => {
    return (
        <Route path='hardware'>
            <Route
                path='gates'
                element={<Gates />}
            />
            <Route
                path='access-controllers'
                element={<AccessControllers />}
            />
            <Route
                path='infrastructure'
                element={<Infrastructure />}
            />
            <Route
                path='dashboard'
                element={<HardwareDashboard />}
            />
        </Route>
    );
};
